export const ErrorRobot = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      preserveAspectRatio="xMidYMid meet"
      width="1727"
      height="1451"
      viewBox="0 0 1727 1451"
      className="h-64 w-64"
    >
      <defs>
        <animateMotion
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_18_G"
          fill="freeze"
          keyTimes="0;0.25;0.5;0.75;0.9979167;1"
          path="M863.27 1231.61 C894.77,1231.61 1039.44,1231.61 1052.27,1231.61 C1065.11,1231.61 979.44,1231.61 940.27,1231.61 C901.11,1231.61 830.11,1231.61 817.27,1231.61 C804.44,1231.61 855.61,1231.61 863.27,1231.61 C863.27,1231.61 863.27,1231.61 863.27,1231.61 "
          keyPoints="0;0.4;0.64;0.89;1;1"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_18_G"
          fill="freeze"
          attributeName="transform"
          from="0.89 0.89"
          to="0.89 0.89"
          type="scale"
          additive="sum"
          keyTimes="0;0.25;0.5;0.75;0.9979167;1"
          values="0.89 0.89;0.72 0.72;0.56 0.56;0.72 0.72;0.89 0.89;0.89 0.89"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_18_G"
          fill="freeze"
          attributeName="transform"
          from="-286.776 -16.359"
          to="-286.776 -16.359"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="-286.776 -16.359;-286.776 -16.359"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_17_G"
          fill="freeze"
          attributeName="transform"
          from="-8"
          to="-8"
          type="rotate"
          additive="sum"
          keyTimes="0;0.25;0.5;0.85;0.9979167;1"
          values="-8;1;9;24;-8;-8"
          keySplines="0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_17_G"
          fill="freeze"
          attributeName="transform"
          from="0.92 0.92"
          to="0.92 0.92"
          type="scale"
          additive="sum"
          keyTimes="0;1"
          values="0.92 0.92;0.92 0.92"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_17_G"
          fill="freeze"
          attributeName="transform"
          from="-158.388 -4.506"
          to="-158.388 -4.506"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="-158.388 -4.506;-158.388 -4.506"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animateMotion
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_17_G_N_13_T_0"
          fill="freeze"
          keyTimes="0;0.2520833;0.5;0.75;0.9979167;1"
          path="M862.96 651.16 C907.96,649.9 1048.96,635.63 1047.73,571.5 C1046.22,492.81 961.73,492.24 923.73,493.16 C910.58,493.48 810.99,502.13 809.99,572.63 C809.06,638.15 836.64,651.89 862.96,651.16 C862.96,651.16 862.96,651.16 862.96,651.16 "
          keyPoints="0;0.34;0.59;0.83;1;1"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_17_G_N_13_T_0"
          fill="freeze"
          attributeName="transform"
          from="-238.219 -294.699"
          to="-238.219 -294.699"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="-238.219 -294.699;-238.219 -294.699"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_16_G"
          fill="freeze"
          attributeName="transform"
          from="6.985"
          to="6.985"
          type="rotate"
          additive="sum"
          keyTimes="0;0.25;0.5;0.85;0.9979167;1"
          values="6.985;0.985;-9.015;-30.015;6.985;6.985"
          keySplines="0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_16_G"
          fill="freeze"
          attributeName="transform"
          from="-12.462 -5.186"
          to="-12.462 -5.186"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="-12.462 -5.186;-12.462 -5.186"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animateMotion
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_16_G_N_13_T_0"
          fill="freeze"
          keyTimes="0;0.2520833;0.5;0.75;0.9979167;1"
          path="M862.96 651.16 C907.96,649.9 1048.96,635.63 1047.73,571.5 C1046.22,492.81 961.73,492.24 923.73,493.16 C910.58,493.48 810.99,502.13 809.99,572.63 C809.06,638.15 836.64,651.89 862.96,651.16 C862.96,651.16 862.96,651.16 862.96,651.16 "
          keyPoints="0;0.34;0.59;0.83;1;1"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_16_G_N_13_T_0"
          fill="freeze"
          attributeName="transform"
          from="-238.219 -294.699"
          to="-238.219 -294.699"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="-238.219 -294.699;-238.219 -294.699"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_15_G"
          fill="freeze"
          attributeName="opacity"
          from="1"
          to="0"
          keyTimes="0;0.15;0.1958333;1"
          values="1;1;0;0"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateMotion
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_15_G"
          fill="freeze"
          keyTimes="0;0.1958333;1"
          path="M1038.06 565.25 C1226.73,495.92 1035.4,344.59 1224.06,269.25 C1224.06,269.25 1224.06,269.25 1224.06,269.25 "
          keyPoints="0;1;1"
          keySplines="0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_15_G"
          fill="freeze"
          attributeName="transform"
          from="0"
          to="-20"
          type="rotate"
          additive="sum"
          keyTimes="0;0.1958333;1"
          values="0;-20;-20"
          keySplines="0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_15_G"
          fill="freeze"
          attributeName="transform"
          from="0.43 0.43"
          to="1.2 1.2"
          type="scale"
          additive="sum"
          keyTimes="0;0.15;1"
          values="0.43 0.43;1.2 1.2;1.2 1.2"
          keySplines="0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_15_G"
          fill="freeze"
          attributeName="transform"
          from="-36.984 -31.919"
          to="-36.984 -31.919"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="-36.984 -31.919;-36.984 -31.919"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_15_G_M"
          fill="freeze"
          attributeName="opacity"
          from="1"
          to="0"
          keyTimes="0;0.2;0.2;1"
          values="1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_14_G"
          fill="freeze"
          attributeName="opacity"
          from="1"
          to="0"
          keyTimes="0;0.3;0.3458333;1"
          values="1;1;0;0"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateMotion
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_14_G"
          fill="freeze"
          keyTimes="0;0.15;0.3458333;1"
          path="M1102.06 493.25 C1102.06,493.25 1102.06,493.25 1102.06,493.25 C1062.73,289.92 1327.4,390.59 1288.06,197.25 C1288.06,197.25 1288.06,197.25 1288.06,197.25 "
          keyPoints="0;0;1;1"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_14_G"
          fill="freeze"
          attributeName="transform"
          from="0"
          to="-17"
          type="rotate"
          additive="sum"
          keyTimes="0;0.15;0.3458333;1"
          values="0;0;-17;-17"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_14_G"
          fill="freeze"
          attributeName="transform"
          from="0.43 0.43"
          to="1.68 1.68"
          type="scale"
          additive="sum"
          keyTimes="0;0.15;0.3;0.3458333;1"
          values="0.43 0.43;0.43 0.43;1.2 1.2;1.68 1.68;1.68 1.68"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_14_G"
          fill="freeze"
          attributeName="transform"
          from="-36.984 -31.919"
          to="-36.984 -31.919"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="-36.984 -31.919;-36.984 -31.919"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_14_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.15;0.1500002;0.35;0.35;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_13_G"
          fill="freeze"
          attributeName="opacity"
          from="1"
          to="0"
          keyTimes="0;0.45;0.4958333;1"
          values="1;1;0;0"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateMotion
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_13_G"
          fill="freeze"
          keyTimes="0;0.3;0.4958333;1"
          path="M1038.06 565.25 C1038.06,565.25 1038.06,565.25 1038.06,565.25 C1226.73,495.92 1035.4,344.59 1224.06,269.25 C1224.06,269.25 1224.06,269.25 1224.06,269.25 "
          keyPoints="0;0;1;1"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_13_G"
          fill="freeze"
          attributeName="transform"
          from="0"
          to="-20"
          type="rotate"
          additive="sum"
          keyTimes="0;0.3;0.4958333;1"
          values="0;0;-20;-20"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_13_G"
          fill="freeze"
          attributeName="transform"
          from="0.43 0.43"
          to="1.2 1.2"
          type="scale"
          additive="sum"
          keyTimes="0;0.3;0.45;1"
          values="0.43 0.43;0.43 0.43;1.2 1.2;1.2 1.2"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_13_G"
          fill="freeze"
          attributeName="transform"
          from="-36.984 -31.919"
          to="-36.984 -31.919"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="-36.984 -31.919;-36.984 -31.919"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_13_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.3;0.3000002;0.5;0.5;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_12_G"
          fill="freeze"
          attributeName="opacity"
          from="1"
          to="0"
          keyTimes="0;0.6;0.6458333;1"
          values="1;1;0;0"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateMotion
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_12_G"
          fill="freeze"
          keyTimes="0;0.45;0.6458333;1"
          path="M1102.06 493.25 C1102.06,493.25 1102.06,493.25 1102.06,493.25 C1062.73,289.92 1327.4,390.59 1288.06,197.25 C1288.06,197.25 1288.06,197.25 1288.06,197.25 "
          keyPoints="0;0;1;1"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_12_G"
          fill="freeze"
          attributeName="transform"
          from="0"
          to="-17"
          type="rotate"
          additive="sum"
          keyTimes="0;0.45;0.6458333;1"
          values="0;0;-17;-17"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_12_G"
          fill="freeze"
          attributeName="transform"
          from="0.43 0.43"
          to="1.68 1.68"
          type="scale"
          additive="sum"
          keyTimes="0;0.45;0.6;0.6458333;1"
          values="0.43 0.43;0.43 0.43;1.2 1.2;1.68 1.68;1.68 1.68"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_12_G"
          fill="freeze"
          attributeName="transform"
          from="-36.984 -31.919"
          to="-36.984 -31.919"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="-36.984 -31.919;-36.984 -31.919"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_12_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.45;0.4500002;0.65;0.65;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_11_G"
          fill="freeze"
          attributeName="opacity"
          from="1"
          to="0"
          keyTimes="0;0.75;0.7958333;1"
          values="1;1;0;0"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateMotion
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_11_G"
          fill="freeze"
          keyTimes="0;0.6;0.7958333;1"
          path="M1038.06 565.25 C1038.06,565.25 1038.06,565.25 1038.06,565.25 C1226.73,495.92 1035.4,344.59 1224.06,269.25 C1224.06,269.25 1224.06,269.25 1224.06,269.25 "
          keyPoints="0;0;1;1"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_11_G"
          fill="freeze"
          attributeName="transform"
          from="0"
          to="-20"
          type="rotate"
          additive="sum"
          keyTimes="0;0.6;0.7958333;1"
          values="0;0;-20;-20"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_11_G"
          fill="freeze"
          attributeName="transform"
          from="0.43 0.43"
          to="1.2 1.2"
          type="scale"
          additive="sum"
          keyTimes="0;0.6;0.75;1"
          values="0.43 0.43;0.43 0.43;1.2 1.2;1.2 1.2"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_11_G"
          fill="freeze"
          attributeName="transform"
          from="-36.984 -31.919"
          to="-36.984 -31.919"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="-36.984 -31.919;-36.984 -31.919"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_11_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.6;0.6000002;0.8;0.8;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_10_G"
          fill="freeze"
          attributeName="opacity"
          from="1"
          to="0"
          keyTimes="0;0.9;0.9458333;1"
          values="1;1;0;0"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateMotion
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_10_G"
          fill="freeze"
          keyTimes="0;0.75;0.9458333;1"
          path="M1102.06 493.25 C1102.06,493.25 1102.06,493.25 1102.06,493.25 C1062.73,289.92 1327.4,390.59 1288.06,197.25 C1288.06,197.25 1288.06,197.25 1288.06,197.25 "
          keyPoints="0;0;1;1"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_10_G"
          fill="freeze"
          attributeName="transform"
          from="0"
          to="-17"
          type="rotate"
          additive="sum"
          keyTimes="0;0.75;0.9458333;1"
          values="0;0;-17;-17"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_10_G"
          fill="freeze"
          attributeName="transform"
          from="0.43 0.43"
          to="1.68 1.68"
          type="scale"
          additive="sum"
          keyTimes="0;0.75;0.9;0.9458333;1"
          values="0.43 0.43;0.43 0.43;1.2 1.2;1.68 1.68;1.68 1.68"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_10_G"
          fill="freeze"
          attributeName="transform"
          from="-36.984 -31.919"
          to="-36.984 -31.919"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="-36.984 -31.919;-36.984 -31.919"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_10_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.75;0.7500002;0.95;0.95;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animateMotion
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_9_G"
          fill="freeze"
          keyTimes="0;0.2520833;0.5;0.75;0.9979167;1"
          path="M862.96 651.16 C907.96,649.9 1048.96,635.63 1047.73,571.5 C1046.22,492.81 961.73,492.24 923.73,493.16 C910.58,493.48 810.99,502.13 809.99,572.63 C809.06,638.15 836.64,651.89 862.96,651.16 C862.96,651.16 862.96,651.16 862.96,651.16 "
          keyPoints="0;0.34;0.59;0.83;1;1"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_9_G"
          fill="freeze"
          attributeName="transform"
          from="-238.219 -294.699"
          to="-238.219 -294.699"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="-238.219 -294.699;-238.219 -294.699"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animateMotion
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_8_G_N_13_T_0"
          fill="freeze"
          keyTimes="0;0.2520833;0.5;0.75;0.9979167;1"
          path="M862.96 651.16 C907.96,649.9 1048.96,635.63 1047.73,571.5 C1046.22,492.81 961.73,492.24 923.73,493.16 C910.58,493.48 810.99,502.13 809.99,572.63 C809.06,638.15 836.64,651.89 862.96,651.16 C862.96,651.16 862.96,651.16 862.96,651.16 "
          keyPoints="0;0.34;0.59;0.83;1;1"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_8_G_N_13_T_0"
          fill="freeze"
          attributeName="transform"
          from="-238.219 -294.699"
          to="-238.219 -294.699"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="-238.219 -294.699;-238.219 -294.699"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animateMotion
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_7_G_N_13_T_0"
          fill="freeze"
          keyTimes="0;0.2520833;0.5;0.75;0.9979167;1"
          path="M862.96 651.16 C907.96,649.9 1048.96,635.63 1047.73,571.5 C1046.22,492.81 961.73,492.24 923.73,493.16 C910.58,493.48 810.99,502.13 809.99,572.63 C809.06,638.15 836.64,651.89 862.96,651.16 C862.96,651.16 862.96,651.16 862.96,651.16 "
          keyPoints="0;0.34;0.59;0.83;1;1"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_7_G_N_13_T_0"
          fill="freeze"
          attributeName="transform"
          from="-238.219 -294.699"
          to="-238.219 -294.699"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="-238.219 -294.699;-238.219 -294.699"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animateMotion
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_6_G"
          fill="freeze"
          keyTimes="0;0.2270833;0.3541667;0.5;0.9979167;1"
          path="M360.51 289.04 C344.08,289.04 299.86,289.04 254.23,289.04 C233.91,289.04 223.31,289.04 204.76,289.04 C166.04,289.04 126.24,289.04 126.51,289.04 C127.17,289.04 324.84,289.04 364.51,289.04 C364.51,289.04 364.51,289.04 364.51,289.04 "
          keyPoints="0;0.23;0.33;0.5;1;1"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_6_G"
          fill="freeze"
          attributeName="transform"
          from="-76.416 -70.25"
          to="-76.416 -70.25"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="-76.416 -70.25;-76.416 -70.25"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animateMotion
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_6_G_N_13_T_0"
          fill="freeze"
          keyTimes="0;0.2520833;0.5;0.75;0.9979167;1"
          path="M862.96 651.16 C907.96,649.9 1048.96,635.63 1047.73,571.5 C1046.22,492.81 961.73,492.24 923.73,493.16 C910.58,493.48 810.99,502.13 809.99,572.63 C809.06,638.15 836.64,651.89 862.96,651.16 C862.96,651.16 862.96,651.16 862.96,651.16 "
          keyPoints="0;0.34;0.59;0.83;1;1"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_6_G_N_13_T_0"
          fill="freeze"
          attributeName="transform"
          from="-238.219 -294.699"
          to="-238.219 -294.699"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="-238.219 -294.699;-238.219 -294.699"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animateMotion
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_5_G_N_13_T_0"
          fill="freeze"
          keyTimes="0;0.2520833;0.5;0.75;0.9979167;1"
          path="M862.96 651.16 C907.96,649.9 1048.96,635.63 1047.73,571.5 C1046.22,492.81 961.73,492.24 923.73,493.16 C910.58,493.48 810.99,502.13 809.99,572.63 C809.06,638.15 836.64,651.89 862.96,651.16 C862.96,651.16 862.96,651.16 862.96,651.16 "
          keyPoints="0;0.34;0.59;0.83;1;1"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_5_G_N_13_T_0"
          fill="freeze"
          attributeName="transform"
          from="-238.219 -294.699"
          to="-238.219 -294.699"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="-238.219 -294.699;-238.219 -294.699"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animateMotion
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_4_G_N_13_T_0"
          fill="freeze"
          keyTimes="0;0.2520833;0.5;0.75;0.9979167;1"
          path="M862.96 651.16 C907.96,649.9 1048.96,635.63 1047.73,571.5 C1046.22,492.81 961.73,492.24 923.73,493.16 C910.58,493.48 810.99,502.13 809.99,572.63 C809.06,638.15 836.64,651.89 862.96,651.16 C862.96,651.16 862.96,651.16 862.96,651.16 "
          keyPoints="0;0.34;0.59;0.83;1;1"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_4_G_N_13_T_0"
          fill="freeze"
          attributeName="transform"
          from="-238.219 -294.699"
          to="-238.219 -294.699"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="-238.219 -294.699;-238.219 -294.699"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animateMotion
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_3_G_N_13_T_0"
          fill="freeze"
          keyTimes="0;0.2520833;0.5;0.75;0.9979167;1"
          path="M862.96 651.16 C907.96,649.9 1048.96,635.63 1047.73,571.5 C1046.22,492.81 961.73,492.24 923.73,493.16 C910.58,493.48 810.99,502.13 809.99,572.63 C809.06,638.15 836.64,651.89 862.96,651.16 C862.96,651.16 862.96,651.16 862.96,651.16 "
          keyPoints="0;0.34;0.59;0.83;1;1"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_3_G_N_13_T_0"
          fill="freeze"
          attributeName="transform"
          from="-238.219 -294.699"
          to="-238.219 -294.699"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="-238.219 -294.699;-238.219 -294.699"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animateMotion
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_2_G_N_13_T_0"
          fill="freeze"
          keyTimes="0;0.2520833;0.5;0.75;0.9979167;1"
          path="M862.96 651.16 C907.96,649.9 1048.96,635.63 1047.73,571.5 C1046.22,492.81 961.73,492.24 923.73,493.16 C910.58,493.48 810.99,502.13 809.99,572.63 C809.06,638.15 836.64,651.89 862.96,651.16 C862.96,651.16 862.96,651.16 862.96,651.16 "
          keyPoints="0;0.34;0.59;0.83;1;1"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_2_G_N_13_T_0"
          fill="freeze"
          attributeName="transform"
          from="-238.219 -294.699"
          to="-238.219 -294.699"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="-238.219 -294.699;-238.219 -294.699"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animateMotion
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_1_G_N_13_T_0"
          fill="freeze"
          keyTimes="0;0.2520833;0.5;0.75;0.9979167;1"
          path="M862.96 651.16 C907.96,649.9 1048.96,635.63 1047.73,571.5 C1046.22,492.81 961.73,492.24 923.73,493.16 C910.58,493.48 810.99,502.13 809.99,572.63 C809.06,638.15 836.64,651.89 862.96,651.16 C862.96,651.16 862.96,651.16 862.96,651.16 "
          keyPoints="0;0.34;0.59;0.83;1;1"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_1_G_N_13_T_0"
          fill="freeze"
          attributeName="transform"
          from="-238.219 -294.699"
          to="-238.219 -294.699"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="-238.219 -294.699;-238.219 -294.699"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animateMotion
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_0_G_N_13_T_0"
          fill="freeze"
          keyTimes="0;0.2520833;0.5;0.75;0.9979167;1"
          path="M862.96 651.16 C907.96,649.9 1048.96,635.63 1047.73,571.5 C1046.22,492.81 961.73,492.24 923.73,493.16 C910.58,493.48 810.99,502.13 809.99,572.63 C809.06,638.15 836.64,651.89 862.96,651.16 C862.96,651.16 862.96,651.16 862.96,651.16 "
          keyPoints="0;0.34;0.59;0.83;1;1"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="20s"
          begin="0s"
          xlinkHref="#_R_G_L_0_G_N_13_T_0"
          fill="freeze"
          attributeName="transform"
          from="-238.219 -294.699"
          to="-238.219 -294.699"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="-238.219 -294.699;-238.219 -294.699"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animate attributeType="XML" attributeName="opacity" dur="20s" from="0" to="1" xlinkHref="#time_group" />
      </defs>
      <g id="_R_G">
        <g id="_R_G_L_19_G" transform=" translate(923.732, 690.249) translate(-735.114, -702.29)">
          <path
            id="_R_G_L_19_G_D_0_P_0"
            className="fill-gray-background"
            fillOpacity="1"
            fillRule="nonzero"
            d=" M1238.54 874.99 C1182.21,1043.47 1469.98,1192.67 1279.8,1347.63 C1240.44,1379.69 1204.45,1382.31 1158.96,1386.9 C1118.9,1390.94 1078.34,1389.58 1038.34,1385.57 C967.62,1378.47 898.05,1363.33 827.37,1355.92 C776.32,1350.57 724.14,1349.34 673.42,1358.12 C624.15,1366.65 597.74,1381.88 548.64,1391.5 C494.03,1402.2 418.52,1404.33 366.92,1384.91 C340.72,1375.04 300.6,1369.57 265.16,1349.32 C244.68,1337.62 207.79,1315.57 190.75,1259.73 C158.65,1154.57 201.63,1129.25 226.47,1027.93 C269.68,851.66 65.46,677.92 65.46,677.92 C0.25,601.83 10.37,515.03 61.91,450.32 C115.58,382.92 218.58,366.3 306.93,364.98 C324.83,364.71 342.18,357.5 352.78,344.17 C379.3,310.84 338,274.35 319.91,239.31 C291.46,184.2 326.34,120.47 375.14,86.54 C471.23,19.73 550.24,69.95 654.45,71.58 C784.45,73.58 937.58,0.25 1055.53,82.41 C1126.97,132.15 1188.73,254.55 1164.03,333.99 C1139.33,413.4 1079.17,458.25 1255.09,626.47 C1255.09,626.47 1366.98,693.88 1323.39,766.03 C1302.78,800.14 1249.25,842.93 1238.54,874.99z "
          />
        </g>
        <g id="_R_G_L_18_G">
          <path
            id="_R_G_L_18_G_D_0_P_0"
            fill="#cccccc"
            fillOpacity="1"
            fillRule="nonzero"
            d=" M573.3 16.36 C573.3,20.63 543.11,24.73 489.38,27.75 C435.65,30.77 362.77,32.47 286.78,32.47 C210.78,32.47 137.91,30.77 84.17,27.75 C30.44,24.73 0.25,20.63 0.25,16.36 C0.25,12.09 30.44,7.99 84.17,4.97 C137.91,1.95 210.78,0.25 286.78,0.25 C362.77,0.25 435.65,1.95 489.38,4.97 C543.11,7.99 573.3,12.09 573.3,16.36z "
          />
        </g>
        <g id="_R_G_L_17_G_N_13_T_0">
          <g id="_R_G_L_17_G" transform=" translate(39.826, 425.47)">
            <path
              id="_R_G_L_17_G_D_0_P_0"
              fill="#000000"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M131.87 3.46 C129.42,6.67 102.87,71.82 102.32,85.15 C102.32,85.15 101.78,98.47 101.78,98.47 C101.78,98.47 119.9,96.08 119.9,96.08 C119.9,95.86 138.37,40.42 145.04,20.42 C148.41,10.29 156.22,0.25 156.22,0.25 C156.22,0.25 131.87,3.46 131.87,3.46z "
            />
            <g id="_R_G_L_17_G_D_1_P_0_G_0_T_0" transform=" translate(129.001, 49.36) translate(0, 0)">
              <path
                id="_R_G_L_17_G_D_1_P_0"
                className="fill-primary"
                fillOpacity="1"
                fillRule="nonzero"
                opacity="0.44"
                d=" M2.87 -45.9 C0.42,-42.69 -26.13,22.46 -26.68,35.78 C-26.68,35.78 -27.22,49.11 -27.22,49.11 C-27.22,49.11 -9.1,46.72 -9.1,46.72 C-9.1,46.5 9.37,-8.94 16.04,-28.94 C19.41,-39.07 27.22,-49.11 27.22,-49.11 C27.22,-49.11 2.87,-45.9 2.87,-45.9z "
              />
            </g>
            <path
              id="_R_G_L_17_G_D_2_P_0"
              fill="#000000"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M94.99 63.92 C90.11,68.19 35.22,139.78 17.73,206.43 C0.25,273.08 26.66,322.15 60.61,332.17 C94.56,342.19 126.46,329.83 128.92,266.06 C131.38,202.3 134.6,96.54 136.02,86.32 C134.42,77.46 122.52,66.87 112.57,64.34 C102.63,61.81 94.99,63.92 94.99,63.92z "
            />
            <g id="_R_G_L_17_G_D_3_P_0_G_0_T_0" transform=" translate(68.137, 201.999) translate(0, 0)">
              <path
                id="_R_G_L_17_G_D_3_P_0"
                className="fill-primary"
                fillOpacity="1"
                fillRule="nonzero"
                opacity="0.66"
                d=" M26.85 -138.08 C21.98,-133.81 -32.92,-62.22 -50.4,4.43 C-67.89,71.08 -41.47,120.16 -7.52,130.17 C26.42,140.19 58.32,127.83 60.78,64.06 C63.24,0.3 66.47,-105.46 67.89,-115.68 C66.28,-124.53 54.38,-135.13 44.44,-137.66 C34.49,-140.19 26.85,-138.08 26.85,-138.08z "
              />
            </g>
            <path
              id="_R_G_L_17_G_D_4_P_0"
              className="fill-primary"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M70.88 96.51 C52.31,124.44 28.26,166.32 17.73,206.43 C4.92,255.29 15.69,294.7 35.73,316.21 C46.48,309.78 56.85,301.99 65.74,292.81 C104.79,252.51 108.19,103.7 93.81,96.24 C88.69,93.58 80.01,94.37 70.88,96.51z "
            />
            <path
              id="_R_G_L_17_G_D_5_P_0"
              fill="#000000"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M94.72 271.6 C101.6,276.88 106.13,284.64 107.3,293.19 C108.47,301.74 106.19,310.37 100.97,317.19 C95.74,324 88,328.44 79.44,329.52 C70.88,330.61 62.2,328.26 55.32,322.98 C48.44,317.7 43.91,309.93 42.74,301.38 C41.57,292.83 43.84,284.2 49.07,277.39 C54.29,270.58 62.04,266.14 70.6,265.05 C79.16,263.96 87.84,266.32 94.72,271.6z "
            />
            <g id="_R_G_L_17_G_D_6_P_0_G_0_T_0" transform=" translate(75.018, 297.287) translate(0, 0)">
              <path
                id="_R_G_L_17_G_D_6_P_0"
                className="fill-primary"
                fillOpacity="1"
                fillRule="nonzero"
                opacity="0.44"
                d=" M19.7 -25.69 C26.58,-20.41 31.11,-12.65 32.28,-4.09 C33.45,4.46 31.18,13.09 25.95,19.9 C20.73,26.71 12.98,31.15 4.42,32.24 C-4.14,33.32 -12.82,30.97 -19.7,25.69 C-26.58,20.41 -31.11,12.65 -32.28,4.1 C-33.45,-4.45 -31.17,-13.08 -25.95,-19.9 C-20.72,-26.71 -12.98,-31.15 -4.42,-32.24 C4.14,-33.32 12.82,-30.97 19.7,-25.69z "
              />
            </g>
            <path
              id="_R_G_L_17_G_D_7_P_0"
              fill="#000000"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M59.82 384.87 C52.8,383.42 48.8,374.24 50.85,364.28 C50.85,364.28 57.84,330.32 57.84,330.32 C59.89,320.36 67.2,313.51 74.22,314.96 C81.24,316.41 85.25,325.58 83.2,335.54 C83.2,335.54 76.2,369.51 76.2,369.51 C74.15,379.46 66.85,386.32 59.82,384.87z "
            />
            <path
              id="_R_G_L_17_G_D_8_P_0"
              fill="#000000"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M20.91 336.65 C17.83,333.13 21.51,324.9 29.16,318.21 C29.16,318.21 36.61,311.7 36.61,311.7 C44.26,305.01 52.91,302.46 55.99,305.98 C59.07,309.51 55.38,317.73 47.73,324.42 C47.73,324.42 40.28,330.93 40.28,330.93 C32.63,337.62 23.99,340.17 20.91,336.65z "
            />
            <path
              id="_R_G_L_17_G_D_9_P_0"
              fill="#000000"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M116.98 350.9 C121.64,348.67 121.85,339.49 117.46,330.32 C117.46,330.32 111.13,317.07 111.13,317.07 C106.74,307.9 99.46,302.31 94.8,304.54 C90.14,306.77 89.93,315.95 94.31,325.11 C94.31,325.11 100.65,338.36 100.65,338.36 C105.04,347.54 112.32,353.12 116.98,350.9z "
            />
            <path
              id="_R_G_L_17_G_D_10_P_0"
              fill="#f3f3f3"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M93.88 92.7 C95.2,93.71 96.07,95.21 96.28,96.86 C96.5,98.51 96.06,100.18 95.04,101.51 C94.03,102.83 92.53,103.69 90.88,103.91 C89.22,104.13 87.55,103.68 86.23,102.67 C84.91,101.66 84.04,100.16 83.83,98.5 C83.61,96.85 84.05,95.18 85.07,93.86 C86.08,92.54 87.58,91.67 89.23,91.45 C90.88,91.24 92.55,91.68 93.88,92.7z "
            />
            <path
              id="_R_G_L_17_G_D_11_P_0"
              fill="#f3f3f3"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M100.55 206.52 C101.01,211.78 100.06,216.94 97.92,220.87 C95.79,224.8 92.64,227.18 89.17,227.47 C81.94,228.09 75.32,219.72 74.38,208.77 C73.44,197.81 78.53,188.43 85.76,187.81 C89.23,187.52 92.74,189.32 95.52,192.83 C98.29,196.34 100.1,201.26 100.55,206.52z "
            />
            <path
              id="_R_G_L_17_G_D_12_P_0"
              fill="#f3f3f3"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M72.46 177.98 C75.59,180.38 76.18,184.86 73.78,187.99 C71.38,191.12 66.9,191.71 63.77,189.31 C60.64,186.91 60.05,182.43 62.45,179.3 C64.85,176.17 69.33,175.58 72.46,177.98z "
            />
            <path
              id="_R_G_L_17_G_D_13_P_0"
              fill="#f3f3f3"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M84.99 161.63 C86.62,162.88 86.92,165.2 85.68,166.83 C84.43,168.45 82.11,168.76 80.48,167.51 C78.86,166.27 78.55,163.94 79.79,162.32 C81.04,160.69 83.37,160.39 84.99,161.63z "
            />
          </g>
        </g>
        <g id="_R_G_L_16_G_N_13_T_0">
          <g id="_R_G_L_16_G" transform=" translate(450.094, 432.88)">
            <path
              id="_R_G_L_16_G_D_0_P_0"
              fill="#000000"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M22.25 3.15 C24.47,6.05 48.46,64.91 48.95,76.95 C48.95,76.95 49.44,88.99 49.44,88.99 C49.44,88.99 33.07,86.83 33.07,86.83 C33.07,86.63 16.96,31.9 8.29,14.93 C2.72,4.02 0.25,0.25 0.25,0.25 C0.25,0.25 22.25,3.15 22.25,3.15z "
            />
            <g id="_R_G_L_16_G_D_1_P_0_G_0_T_0" transform=" translate(24.846, 44.62) translate(0, 0)">
              <path
                id="_R_G_L_16_G_D_1_P_0"
                className="fill-primary"
                fillOpacity="1"
                fillRule="nonzero"
                opacity="0.44"
                d=" M-2.6 -41.47 C-0.37,-38.57 23.61,20.29 24.1,32.33 C24.1,32.33 24.6,44.37 24.6,44.37 C24.6,44.37 8.22,42.21 8.22,42.21 C8.22,42.01 -7.89,-12.72 -16.55,-29.69 C-22.12,-40.6 -24.6,-44.37 -24.6,-44.37 C-24.6,-44.37 -2.6,-41.47 -2.6,-41.47z "
              />
            </g>
            <path
              id="_R_G_L_16_G_D_2_P_0"
              fill="#000000"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M58.57 69.85 C62.97,73.71 112.57,138.39 128.37,198.61 C144.16,258.83 120.3,303.16 89.63,312.22 C58.96,321.27 30.13,310.1 27.91,252.49 C25.69,194.88 22.77,99.32 21.49,90.09 C22.94,82.09 33.69,72.52 42.68,70.23 C51.66,67.94 58.57,69.85 58.57,69.85z "
            />
            <g id="_R_G_L_16_G_D_3_P_0_G_0_T_0" transform=" translate(82.826, 194.607) translate(0, 0)">
              <path
                id="_R_G_L_16_G_D_3_P_0"
                className="fill-primary"
                fillOpacity="1"
                fillRule="nonzero"
                opacity="0.66"
                d=" M-24.26 -124.76 C-19.85,-120.9 29.74,-56.22 45.54,4 C61.34,64.22 37.47,108.56 6.8,117.61 C-23.87,126.66 -52.69,115.49 -54.91,57.88 C-57.14,0.27 -60.05,-95.28 -61.34,-104.51 C-59.89,-112.51 -49.14,-122.09 -40.15,-124.38 C-31.16,-126.66 -24.26,-124.76 -24.26,-124.76z "
              />
            </g>
            <path
              id="_R_G_L_16_G_D_4_P_0"
              className="fill-primary"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M80.35 99.3 C97.12,124.54 118.86,162.37 128.37,198.61 C139.95,242.75 130.21,278.36 112.1,297.79 C102.39,291.99 93.02,284.95 84.99,276.65 C49.71,240.25 46.64,105.79 59.63,99.05 C64.25,96.65 72.1,97.37 80.35,99.3z "
            />
            <path
              id="_R_G_L_16_G_D_5_P_0"
              fill="#000000"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M58.81 257.49 C52.59,262.26 48.51,269.27 47.45,277 C46.39,284.73 48.44,292.52 53.16,298.68 C57.88,304.83 64.88,308.84 72.62,309.83 C80.35,310.81 88.19,308.68 94.41,303.91 C100.63,299.14 104.71,292.12 105.77,284.4 C106.83,276.68 104.78,268.88 100.06,262.72 C95.34,256.57 88.34,252.55 80.6,251.57 C72.87,250.59 65.03,252.72 58.81,257.49z "
            />
            <g id="_R_G_L_16_G_D_6_P_0_G_0_T_0" transform=" translate(76.61, 280.699) translate(0, 0)">
              <path
                id="_R_G_L_16_G_D_6_P_0"
                className="fill-primary"
                fillOpacity="1"
                fillRule="nonzero"
                opacity="0.44"
                d=" M-17.8 -23.21 C-24.02,-18.44 -28.1,-11.42 -29.16,-3.7 C-30.22,4.03 -28.17,11.82 -23.45,17.98 C-18.73,24.14 -11.73,28.14 -3.99,29.13 C3.74,30.11 11.58,27.98 17.8,23.21 C24.02,18.44 28.1,11.43 29.16,3.7 C30.22,-4.02 28.17,-11.82 23.45,-17.98 C18.73,-24.13 11.73,-28.14 3.99,-29.13 C-3.74,-30.11 -11.58,-27.98 -17.8,-23.21z "
              />
            </g>
            <path
              id="_R_G_L_16_G_D_7_P_0"
              fill="#000000"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M90.34 359.83 C96.68,358.52 100.3,350.23 98.45,341.23 C98.45,341.23 92.13,310.54 92.13,310.54 C90.28,301.55 83.68,295.36 77.33,296.66 C70.99,297.97 67.37,306.27 69.22,315.26 C69.22,315.26 75.54,345.95 75.54,345.95 C77.39,354.95 83.99,361.14 90.34,359.83z "
            />
            <path
              id="_R_G_L_16_G_D_8_P_0"
              fill="#000000"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M125.5 316.26 C128.29,313.08 124.96,305.65 118.04,299.6 C118.04,299.6 111.31,293.72 111.31,293.72 C104.4,287.68 96.59,285.38 93.81,288.56 C91.02,291.74 94.35,299.17 101.27,305.22 C101.27,305.22 107.99,311.1 107.99,311.1 C114.91,317.14 122.72,319.45 125.5,316.26z "
            />
            <path
              id="_R_G_L_16_G_D_9_P_0"
              fill="#000000"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M38.7 329.14 C34.49,327.12 34.29,318.83 38.26,310.55 C38.26,310.55 43.99,298.57 43.99,298.57 C47.95,290.29 54.53,285.24 58.74,287.25 C62.94,289.27 63.14,297.56 59.18,305.84 C59.18,305.84 53.45,317.81 53.45,317.81 C49.48,326.1 42.91,331.15 38.7,329.14z "
            />
            <path
              id="_R_G_L_16_G_D_10_P_0"
              fill="#f3f3f3"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M59.57 95.85 C58.38,96.77 57.6,98.12 57.4,99.61 C57.2,101.11 57.6,102.62 58.52,103.81 C59.44,105.01 60.79,105.79 62.28,105.99 C63.78,106.18 65.29,105.78 66.48,104.86 C67.67,103.95 68.46,102.59 68.65,101.1 C68.85,99.61 68.45,98.1 67.53,96.9 C66.61,95.71 65.26,94.93 63.77,94.73 C62.27,94.53 60.77,94.94 59.57,95.85z "
            />
            <path
              id="_R_G_L_16_G_D_11_P_0"
              fill="#f3f3f3"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M53.54 198.69 C53.13,203.44 53.98,208.11 55.91,211.66 C57.84,215.21 60.69,217.35 63.83,217.62 C70.36,218.18 76.34,210.62 77.19,200.72 C78.04,190.83 73.43,182.35 66.9,181.79 C63.76,181.52 60.59,183.15 58.09,186.32 C55.58,189.49 53.94,193.94 53.54,198.69z "
            />
            <path
              id="_R_G_L_16_G_D_12_P_0"
              fill="#f3f3f3"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M78.92 172.9 C76.1,175.07 75.56,179.12 77.73,181.95 C79.9,184.78 83.95,185.31 86.77,183.14 C89.6,180.98 90.14,176.93 87.97,174.1 C85.8,171.27 81.75,170.74 78.92,172.9z "
            />
            <path
              id="_R_G_L_16_G_D_13_P_0"
              fill="#f3f3f3"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M67.6 158.14 C66.13,159.26 65.85,161.36 66.98,162.83 C68.11,164.3 70.21,164.58 71.68,163.45 C73.14,162.33 73.42,160.22 72.29,158.76 C71.17,157.29 69.07,157.01 67.6,158.14z "
            />
          </g>
        </g>
        <g id="_R_G_L_15_G_M">
          <g id="_R_G_L_15_G">
            <path
              id="_R_G_L_15_G_D_0_P_0"
              fill="#ff9800"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M22.89 0.62 C19.86,1.28 17.59,3.79 17.21,6.86 C16.84,9.94 18.45,12.92 21.24,14.29 C21.24,14.29 43.15,25.43 43.15,25.43 C43.15,25.43 6.63,31.7 6.63,31.7 C3.45,32.25 1.01,34.82 0.63,38.03 C0.25,41.24 2.03,44.32 5,45.59 C5,45.59 45.19,62.78 45.19,62.78 C46.97,63.55 48.99,63.59 50.79,62.87 C52.6,62.15 54.04,60.75 54.81,58.96 C55.57,57.18 55.59,55.16 54.86,53.36 C54.13,51.56 52.72,50.12 50.93,49.37 C50.93,49.37 33.44,41.89 33.44,41.89 C33.44,41.89 67.27,36.09 67.27,36.09 C70.37,35.56 72.78,33.1 73.25,30 C73.72,26.89 72.15,23.83 69.35,22.41 C69.35,22.41 27.85,1.29 27.85,1.29 C26.33,0.49 24.57,0.25 22.89,0.62z "
            />
          </g>
        </g>
        <g id="_R_G_L_14_G_M">
          <g id="_R_G_L_14_G">
            <path
              id="_R_G_L_14_G_D_0_P_0"
              fill="#ff9800"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M22.89 0.62 C19.86,1.28 17.59,3.79 17.21,6.86 C16.84,9.94 18.45,12.92 21.24,14.29 C21.24,14.29 43.15,25.43 43.15,25.43 C43.15,25.43 6.63,31.7 6.63,31.7 C3.45,32.25 1.01,34.82 0.63,38.03 C0.25,41.24 2.03,44.32 5,45.59 C5,45.59 45.19,62.78 45.19,62.78 C46.97,63.55 48.99,63.59 50.79,62.87 C52.6,62.15 54.04,60.75 54.81,58.96 C55.57,57.18 55.59,55.16 54.86,53.36 C54.13,51.56 52.72,50.12 50.93,49.37 C50.93,49.37 33.44,41.89 33.44,41.89 C33.44,41.89 67.27,36.09 67.27,36.09 C70.37,35.56 72.78,33.1 73.25,30 C73.72,26.89 72.15,23.83 69.35,22.41 C69.35,22.41 27.85,1.29 27.85,1.29 C26.33,0.49 24.57,0.25 22.89,0.62z "
            />
          </g>
        </g>
        <g id="_R_G_L_13_G_M">
          <g id="_R_G_L_13_G">
            <path
              id="_R_G_L_13_G_D_0_P_0"
              fill="#ff9800"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M22.89 0.62 C19.86,1.28 17.59,3.79 17.21,6.86 C16.84,9.94 18.45,12.92 21.24,14.29 C21.24,14.29 43.15,25.43 43.15,25.43 C43.15,25.43 6.63,31.7 6.63,31.7 C3.45,32.25 1.01,34.82 0.63,38.03 C0.25,41.24 2.03,44.32 5,45.59 C5,45.59 45.19,62.78 45.19,62.78 C46.97,63.55 48.99,63.59 50.79,62.87 C52.6,62.15 54.04,60.75 54.81,58.96 C55.57,57.18 55.59,55.16 54.86,53.36 C54.13,51.56 52.72,50.12 50.93,49.37 C50.93,49.37 33.44,41.89 33.44,41.89 C33.44,41.89 67.27,36.09 67.27,36.09 C70.37,35.56 72.78,33.1 73.25,30 C73.72,26.89 72.15,23.83 69.35,22.41 C69.35,22.41 27.85,1.29 27.85,1.29 C26.33,0.49 24.57,0.25 22.89,0.62z "
            />
          </g>
        </g>
        <g id="_R_G_L_12_G_M">
          <g id="_R_G_L_12_G">
            <path
              id="_R_G_L_12_G_D_0_P_0"
              fill="#ff9800"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M22.89 0.62 C19.86,1.28 17.59,3.79 17.21,6.86 C16.84,9.94 18.45,12.92 21.24,14.29 C21.24,14.29 43.15,25.43 43.15,25.43 C43.15,25.43 6.63,31.7 6.63,31.7 C3.45,32.25 1.01,34.82 0.63,38.03 C0.25,41.24 2.03,44.32 5,45.59 C5,45.59 45.19,62.78 45.19,62.78 C46.97,63.55 48.99,63.59 50.79,62.87 C52.6,62.15 54.04,60.75 54.81,58.96 C55.57,57.18 55.59,55.16 54.86,53.36 C54.13,51.56 52.72,50.12 50.93,49.37 C50.93,49.37 33.44,41.89 33.44,41.89 C33.44,41.89 67.27,36.09 67.27,36.09 C70.37,35.56 72.78,33.1 73.25,30 C73.72,26.89 72.15,23.83 69.35,22.41 C69.35,22.41 27.85,1.29 27.85,1.29 C26.33,0.49 24.57,0.25 22.89,0.62z "
            />
          </g>
        </g>
        <g id="_R_G_L_11_G_M">
          <g id="_R_G_L_11_G">
            <path
              id="_R_G_L_11_G_D_0_P_0"
              fill="#ff9800"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M22.89 0.62 C19.86,1.28 17.59,3.79 17.21,6.86 C16.84,9.94 18.45,12.92 21.24,14.29 C21.24,14.29 43.15,25.43 43.15,25.43 C43.15,25.43 6.63,31.7 6.63,31.7 C3.45,32.25 1.01,34.82 0.63,38.03 C0.25,41.24 2.03,44.32 5,45.59 C5,45.59 45.19,62.78 45.19,62.78 C46.97,63.55 48.99,63.59 50.79,62.87 C52.6,62.15 54.04,60.75 54.81,58.96 C55.57,57.18 55.59,55.16 54.86,53.36 C54.13,51.56 52.72,50.12 50.93,49.37 C50.93,49.37 33.44,41.89 33.44,41.89 C33.44,41.89 67.27,36.09 67.27,36.09 C70.37,35.56 72.78,33.1 73.25,30 C73.72,26.89 72.15,23.83 69.35,22.41 C69.35,22.41 27.85,1.29 27.85,1.29 C26.33,0.49 24.57,0.25 22.89,0.62z "
            />
          </g>
        </g>
        <g id="_R_G_L_10_G_M">
          <g id="_R_G_L_10_G">
            <path
              id="_R_G_L_10_G_D_0_P_0"
              fill="#ff9800"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M22.89 0.62 C19.86,1.28 17.59,3.79 17.21,6.86 C16.84,9.94 18.45,12.92 21.24,14.29 C21.24,14.29 43.15,25.43 43.15,25.43 C43.15,25.43 6.63,31.7 6.63,31.7 C3.45,32.25 1.01,34.82 0.63,38.03 C0.25,41.24 2.03,44.32 5,45.59 C5,45.59 45.19,62.78 45.19,62.78 C46.97,63.55 48.99,63.59 50.79,62.87 C52.6,62.15 54.04,60.75 54.81,58.96 C55.57,57.18 55.59,55.16 54.86,53.36 C54.13,51.56 52.72,50.12 50.93,49.37 C50.93,49.37 33.44,41.89 33.44,41.89 C33.44,41.89 67.27,36.09 67.27,36.09 C70.37,35.56 72.78,33.1 73.25,30 C73.72,26.89 72.15,23.83 69.35,22.41 C69.35,22.41 27.85,1.29 27.85,1.29 C26.33,0.49 24.57,0.25 22.89,0.62z "
            />
          </g>
        </g>
        <g id="_R_G_L_9_G">
          <path
            id="_R_G_L_9_G_D_0_P_0"
            className="fill-primary"
            fillOpacity="1"
            fillRule="nonzero"
            d=" M476.19 351.22 C476.19,414.32 451.12,474.84 406.5,519.46 C361.88,564.08 301.36,589.15 238.26,589.15 C175.15,589.15 114.64,564.08 70.02,519.46 C25.4,474.84 0.33,414.32 0.33,351.22 C0.33,288.12 25.4,227.6 70.02,182.98 C114.64,138.36 175.15,113.29 238.26,113.29 C301.36,113.29 361.88,138.36 406.5,182.98 C451.12,227.6 476.19,288.12 476.19,351.22z "
          />
          <path
            id="_R_G_L_9_G_D_1_P_0"
            fill="#000000"
            fillOpacity="1"
            fillRule="nonzero"
            d=" M458.96 262.65 C399.2,276.71 305.09,298.78 234.75,304.29 C182.82,308.37 88.73,304.4 5.93,300.58 C2.26,317.21 0.38,334.19 0.33,351.22 C0.43,392.17 11.1,432.4 31.3,468.02 C30.18,462.95 29.57,458.26 29.66,454.13 C30.39,419.1 53.98,426.04 71.26,425.66 C94.62,430.77 409.18,416.17 427.42,426.39 C443.63,435.47 441.98,462.96 433.23,487.4 C461.16,447.47 476.15,399.94 476.19,351.22 C476.15,320.87 470.3,290.8 458.96,262.65z "
          />
          <g id="_R_G_L_9_G_D_2_P_0_G_0_T_0" transform=" translate(238.34, 375.207) translate(0, 0)">
            <path
              id="_R_G_L_9_G_D_2_P_0"
              className="fill-primary"
              fillOpacity="1"
              fillRule="nonzero"
              opacity="0.66"
              d=" M220.71 -112.37 C160.94,-98.31 66.83,-76.25 -3.51,-70.73 C-55.44,-66.66 -149.53,-70.62 -232.33,-74.45 C-236,-57.82 -237.88,-40.84 -237.93,-23.8 C-237.83,17.15 -227.16,57.38 -206.95,93 C-208.08,87.92 -208.68,83.24 -208.6,79.1 C-207.87,44.07 -184.28,51.02 -167,50.64 C-143.64,55.75 170.92,41.15 189.17,51.37 C205.37,60.44 203.73,87.93 194.98,112.37 C222.9,72.45 237.89,24.92 237.93,-23.8 C237.89,-54.16 232.04,-84.22 220.71,-112.37z "
            />
          </g>
          <path
            id="_R_G_L_9_G_D_3_P_0"
            className="fill-primary"
            fillOpacity="1"
            fillRule="nonzero"
            d=" M269.73 119.31 C269.73,120.13 266.83,120.92 261.66,121.5 C256.5,122.09 249.49,122.41 242.18,122.41 C234.87,122.41 227.87,122.09 222.7,121.5 C217.53,120.92 214.63,120.13 214.63,119.31 C214.63,118.49 217.53,117.7 222.7,117.12 C227.87,116.54 234.87,116.21 242.18,116.21 C249.49,116.21 256.5,116.54 261.66,117.12 C266.83,117.7 269.73,118.49 269.73,119.31z "
          />
          <path
            id="_R_G_L_9_G_D_4_P_0"
            fill="#000000"
            fillOpacity="1"
            fillRule="nonzero"
            d=" M244.78 118.95 C244.78,118.95 244.78,5.27 244.78,5.27 C244.78,5.27 239.58,5.27 239.58,5.27 C239.58,5.27 239.58,118.5 239.58,118.5 C239.58,118.5 244.78,118.95 244.78,118.95z "
          />
          <path
            id="_R_G_L_9_G_D_5_P_0"
            fill="#000000"
            fillOpacity="1"
            fillRule="nonzero"
            d=" M240.89 81.86 C227.74,81.86 217.15,92.45 217.15,105.6 C217.15,105.6 217.15,120.31 217.15,120.31 C217.15,120.31 267.21,120.31 267.21,120.31 C267.21,120.31 267.21,105.6 267.21,105.6 C267.21,92.45 256.62,81.86 243.47,81.86 C243.47,81.86 240.89,81.86 240.89,81.86z "
          />
          <path
            id="_R_G_L_9_G_D_6_P_0"
            fill="#000000"
            fillOpacity="1"
            fillRule="nonzero"
            d=" M241.57 67.27 C235.32,67.27 230.29,73.53 230.29,81.32 C230.29,81.32 230.29,90.02 230.29,90.02 C230.29,90.02 254.07,90.02 254.07,90.02 C254.07,90.02 254.07,81.32 254.07,81.32 C254.07,73.53 249.04,67.27 242.79,67.27 C242.79,67.27 241.57,67.27 241.57,67.27z "
          />
          <path
            id="_R_G_L_9_G_D_7_P_0"
            fill="#000000"
            fillOpacity="1"
            fillRule="nonzero"
            d=" M251.66 9.73 C251.66,14.97 247.42,19.22 242.18,19.22 C236.94,19.22 232.7,14.97 232.7,9.73 C232.7,7.22 233.7,4.81 235.48,3.03 C237.25,1.25 239.67,0.25 242.18,0.25 C244.7,0.25 247.11,1.25 248.89,3.03 C250.66,4.81 251.66,7.22 251.66,9.73z "
          />
          <path
            id="_R_G_L_9_G_D_8_P_0"
            fill="#000000"
            fillOpacity="1"
            fillRule="nonzero"
            d=" M476.11 350.5 C476.11,348.16 476.07,345.83 476,343.5 C474.37,398.91 453.44,451.93 416.99,493.46 C413.21,497.76 406.77,498.31 402.18,494.88 C376.51,475.68 345.2,465.12 312.79,465.08 C279.45,465.12 247.07,476.3 220.8,496.84 C201.67,511.81 186.58,531.13 176.68,553.02 C173.56,559.92 165.63,563.21 158.5,560.67 C125.5,548.95 95.17,529.98 69.94,504.74 C26.97,461.77 2.15,404.06 0.36,343.5 C0.3,345.83 0.25,348.16 0.25,350.5 C0.25,413.6 25.32,474.12 69.94,518.74 C97.58,546.38 131.31,566.5 167.98,577.83 C167.93,578.04 167.87,578.26 167.82,578.47 C190.63,585.55 214.37,589.15 238.26,589.15 C306.86,589.08 372.09,559.41 417.21,507.74 C417.13,507.66 417.03,507.57 416.95,507.49 C454.96,464.21 476.11,408.45 476.11,350.5z "
          />
          <g id="_R_G_L_9_G_D_9_P_0_G_0_T_0" transform=" translate(238.18, 466.324) translate(0, 0)">
            <path
              id="_R_G_L_9_G_D_9_P_0"
              className="fill-primary"
              fillOpacity="1"
              fillRule="nonzero"
              opacity="0.66"
              d=" M237.93 -115.82 C237.93,-118.16 237.89,-120.49 237.82,-122.82 C236.19,-67.41 215.26,-14.39 178.81,27.13 C175.03,31.43 168.58,31.98 164,28.56 C138.33,9.36 107.02,-1.2 74.61,-1.25 C41.27,-1.21 8.89,9.97 -17.38,30.52 C-36.51,45.49 -51.6,64.8 -61.5,86.7 C-64.62,93.59 -72.55,96.88 -79.68,94.35 C-112.68,82.62 -143.01,63.65 -168.24,38.42 C-211.21,-4.55 -236.03,-62.26 -237.82,-122.82 C-237.88,-120.49 -237.93,-118.16 -237.93,-115.82 C-237.93,-52.72 -212.86,7.8 -168.24,52.42 C-140.6,80.05 -106.87,100.18 -70.2,111.5 C-70.25,111.72 -70.31,111.93 -70.36,112.15 C-47.55,119.23 -23.81,122.82 0.08,122.82 C68.68,122.76 133.9,93.08 179.03,41.42 C178.95,41.33 178.85,41.25 178.77,41.16 C216.77,-2.12 237.93,-57.87 237.93,-115.82z "
            />
          </g>
        </g>
        <g id="_R_G_L_8_G_N_13_T_0">
          <g id="_R_G_L_8_G" transform=" translate(236.481, 279.67) translate(-211.75, -88.881)">
            <path
              id="_R_G_L_8_G_D_0_P_0"
              fill="#000000"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M66 0.25 C66,0.25 357.5,0.25 357.5,0.25 C393.93,0.25 423.25,21.85 423.25,48.67 C423.25,48.67 423.25,129.09 423.25,129.09 C423.25,155.91 393.93,177.51 357.5,177.51 C357.5,177.51 66,177.51 66,177.51 C29.57,177.51 0.25,155.91 0.25,129.09 C0.25,129.09 0.25,48.67 0.25,48.67 C0.25,21.85 29.57,0.25 66,0.25z "
            />
          </g>
        </g>
        <g id="_R_G_L_7_G_N_13_T_0">
          <g id="_R_G_L_7_G" opacity="0.44" transform=" translate(236.481, 279.67) translate(-211.75, -88.881)">
            <path
              id="_R_G_L_7_G_D_0_P_0"
              className="fill-primary"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M66 0.25 C66,0.25 357.5,0.25 357.5,0.25 C393.93,0.25 423.25,21.85 423.25,48.67 C423.25,48.67 423.25,129.09 423.25,129.09 C423.25,155.91 393.93,177.51 357.5,177.51 C357.5,177.51 66,177.51 66,177.51 C29.57,177.51 0.25,155.91 0.25,129.09 C0.25,129.09 0.25,48.67 0.25,48.67 C0.25,21.85 29.57,0.25 66,0.25z "
            />
          </g>
        </g>
        <g id="_R_G_L_6_G_N_13_T_0">
          <g id="_R_G_L_6_G">
            <path
              id="_R_G_L_6_G_D_0_P_0"
              fill="#ffffff"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M84.89 0.25 C84.89,0.25 24.89,140.25 24.89,140.25 C24.89,140.25 94.89,136.25 94.89,136.25 C94.89,136.25 152.58,8.63 152.58,8.63 C152.58,8.63 84.89,0.25 84.89,0.25z "
            />
            <path
              id="_R_G_L_6_G_D_1_P_0"
              fill="#ffffff"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M50.88 1.12 C50.88,1.12 0.25,132.71 0.25,132.71 C0.25,132.71 20.2,133.64 20.2,133.64 C20.2,133.64 67.17,13.88 67.17,13.88 C67.17,13.88 50.88,1.12 50.88,1.12z "
            />
          </g>
        </g>
        <g id="_R_G_L_5_G_N_13_T_0">
          <g id="_R_G_L_5_G" transform=" translate(177.984, 376.043) translate(-863.5, -725.5)">
            <path
              id="_R_G_L_5_G_D_0_P_0"
              fill="#000000"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M1095.26 770.73 C1095.26,770.73 752.28,770.73 752.28,770.73 C709.42,770.73 674.92,736.22 674.92,693.36 C674.92,693.36 674.92,700.36 674.92,700.36 C674.92,743.22 709.42,777.73 752.28,777.73 C752.28,777.73 1095.26,777.73 1095.26,777.73 C1138.12,777.73 1172.62,743.22 1172.62,700.36 C1172.62,700.36 1172.62,693.36 1172.62,693.36 C1172.62,736.22 1138.12,770.73 1095.26,770.73z "
            />
            <path
              id="_R_G_L_5_G_D_1_P_0"
              fill="#000000"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M1095.26 770.73 C1095.26,770.73 752.28,770.73 752.28,770.73 C709.42,770.73 674.92,736.22 674.92,693.36 C674.92,693.36 674.92,700.36 674.92,700.36 C674.92,743.22 709.42,777.73 752.28,777.73 C752.28,777.73 1095.26,777.73 1095.26,777.73 C1138.12,777.73 1172.62,743.22 1172.62,700.36 C1172.62,700.36 1172.62,693.36 1172.62,693.36 C1172.62,736.22 1138.12,770.73 1095.26,770.73z "
            />
          </g>
        </g>
        <g id="_R_G_L_4_G_N_13_T_0">
          <g id="_R_G_L_4_G" opacity="0.23" transform=" translate(177.984, 376.043) translate(-863.5, -725.5)">
            <path
              id="_R_G_L_4_G_D_0_P_0"
              className="fill-primary"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M1095.26 770.73 C1095.26,770.73 752.28,770.73 752.28,770.73 C709.42,770.73 674.92,736.22 674.92,693.36 C674.92,693.36 674.92,700.36 674.92,700.36 C674.92,743.22 709.42,777.73 752.28,777.73 C752.28,777.73 1095.26,777.73 1095.26,777.73 C1138.12,777.73 1172.62,743.22 1172.62,700.36 C1172.62,700.36 1172.62,693.36 1172.62,693.36 C1172.62,736.22 1138.12,770.73 1095.26,770.73z "
            />
            <path
              id="_R_G_L_4_G_D_1_P_0"
              className="fill-primary"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M1095.26 770.73 C1095.26,770.73 752.28,770.73 752.28,770.73 C709.42,770.73 674.92,736.22 674.92,693.36 C674.92,693.36 674.92,700.36 674.92,700.36 C674.92,743.22 709.42,777.73 752.28,777.73 C752.28,777.73 1095.26,777.73 1095.26,777.73 C1138.12,777.73 1172.62,743.22 1172.62,700.36 C1172.62,700.36 1172.62,693.36 1172.62,693.36 C1172.62,736.22 1138.12,770.73 1095.26,770.73z "
            />
          </g>
        </g>
        <g id="_R_G_L_3_G_N_13_T_0">
          <g id="_R_G_L_3_G" transform=" translate(178.484, 375.043) translate(-863.5, -725.5)">
            <path
              id="_R_G_L_3_G_D_0_P_0"
              fill="#000000"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M1113.88 629.49 C1113.66,629.05 1113.43,628.62 1113.19,628.2 C1112.86,627.62 1112.51,627.05 1112.14,626.51 C1111.84,626.08 1111.54,625.66 1111.21,625.25 C1111.01,625 1110.8,624.75 1110.59,624.51 C1110.16,624.03 1109.72,623.58 1109.27,623.15 C1109.23,623.12 1109.2,623.09 1109.17,623.06 C1108.78,622.7 1108.38,622.37 1107.96,622.04 C1107.84,621.95 1107.72,621.86 1107.6,621.77 C1106.33,620.84 1104.96,620.1 1103.52,619.58 C1103.13,619.44 1102.74,619.31 1102.34,619.21 C1101.09,618.87 1099.79,618.68 1098.45,618.68 C1098.45,618.68 761.86,618.68 761.86,618.68 C760.92,618.68 760,618.77 759.11,618.94 C757.91,619.16 756.75,619.54 755.65,620.04 C755.37,620.17 755.1,620.3 754.83,620.44 C752.94,621.43 751.22,622.82 749.72,624.51 C749.51,624.75 749.3,625 749.1,625.25 C746.14,628.95 744.22,633.94 743.9,639.5 C743.64,638.2 743.5,636.87 743.5,635.5 C743.5,635.5 743.5,630.02 743.5,630.02 C743.5,618.83 752.57,609.76 763.76,609.76 C763.76,609.76 1096.24,609.76 1096.24,609.76 C1107.43,609.76 1116.5,618.83 1116.5,630.02 C1116.5,630.02 1116.5,635.5 1116.5,635.5 C1116.5,636.38 1116.42,637.23 1116.31,638.08 C1115.97,634.97 1115.13,632.06 1113.88,629.49z "
            />
            <path
              id="_R_G_L_3_G_D_1_P_0"
              fill="#000000"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M1113.88 629.49 C1113.66,629.05 1113.43,628.62 1113.19,628.2 C1112.86,627.62 1112.51,627.05 1112.14,626.52 C1111.84,626.08 1111.54,625.66 1111.21,625.25 C1111.01,625 1110.8,624.75 1110.59,624.51 C1110.16,624.03 1109.72,623.58 1109.27,623.15 C1109.23,623.12 1109.2,623.09 1109.17,623.06 C1108.78,622.7 1108.38,622.37 1107.96,622.04 C1107.84,621.95 1107.72,621.86 1107.6,621.77 C1106.33,620.84 1104.96,620.1 1103.52,619.58 C1103.13,619.44 1102.74,619.31 1102.34,619.21 C1101.09,618.87 1099.79,618.68 1098.45,618.68 C1098.45,618.68 761.86,618.68 761.86,618.68 C760.92,618.68 760,618.77 759.11,618.94 C757.91,619.16 756.75,619.54 755.65,620.04 C755.37,620.17 755.1,620.3 754.83,620.44 C752.94,621.43 751.22,622.82 749.72,624.51 C749.51,624.75 749.3,625 749.1,625.25 C746.14,628.95 744.22,633.94 743.9,639.5 C743.64,638.2 743.5,636.87 743.5,635.5 C743.5,635.5 743.5,630.02 743.5,630.02 C743.5,618.83 752.57,609.76 763.76,609.76 C763.76,609.76 1096.24,609.76 1096.24,609.76 C1107.43,609.76 1116.5,618.83 1116.5,630.02 C1116.5,630.02 1116.5,635.5 1116.5,635.5 C1116.5,636.38 1116.42,637.24 1116.31,638.08 C1115.97,634.97 1115.13,632.06 1113.88,629.49z "
            />
          </g>
        </g>
        <g id="_R_G_L_2_G_N_13_T_0">
          <g id="_R_G_L_2_G" opacity="0.23" transform=" translate(178.484, 375.043) translate(-863.5, -725.5)">
            <path
              id="_R_G_L_2_G_D_0_P_0"
              className="fill-primary"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M1113.88 629.49 C1113.66,629.05 1113.43,628.62 1113.19,628.2 C1112.86,627.62 1112.51,627.05 1112.14,626.51 C1111.84,626.08 1111.54,625.66 1111.21,625.25 C1111.01,625 1110.8,624.75 1110.59,624.51 C1110.16,624.03 1109.72,623.58 1109.27,623.15 C1109.23,623.12 1109.2,623.09 1109.17,623.06 C1108.78,622.7 1108.38,622.37 1107.96,622.04 C1107.84,621.95 1107.72,621.86 1107.6,621.77 C1106.33,620.84 1104.96,620.1 1103.52,619.58 C1103.13,619.44 1102.74,619.31 1102.34,619.21 C1101.09,618.87 1099.79,618.68 1098.45,618.68 C1098.45,618.68 761.86,618.68 761.86,618.68 C760.92,618.68 760,618.77 759.11,618.94 C757.91,619.16 756.75,619.54 755.65,620.04 C755.37,620.17 755.1,620.3 754.83,620.44 C752.94,621.43 751.22,622.82 749.72,624.51 C749.51,624.75 749.3,625 749.1,625.25 C746.14,628.95 744.22,633.94 743.9,639.5 C743.64,638.2 743.5,636.87 743.5,635.5 C743.5,635.5 743.5,630.02 743.5,630.02 C743.5,618.83 752.57,609.76 763.76,609.76 C763.76,609.76 1096.24,609.76 1096.24,609.76 C1107.43,609.76 1116.5,618.83 1116.5,630.02 C1116.5,630.02 1116.5,635.5 1116.5,635.5 C1116.5,636.38 1116.42,637.23 1116.31,638.08 C1115.97,634.97 1115.13,632.06 1113.88,629.49z "
            />
            <path
              id="_R_G_L_2_G_D_1_P_0"
              className="fill-primary"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M1113.88 629.49 C1113.66,629.05 1113.43,628.62 1113.19,628.2 C1112.86,627.62 1112.51,627.05 1112.14,626.52 C1111.84,626.08 1111.54,625.66 1111.21,625.25 C1111.01,625 1110.8,624.75 1110.59,624.51 C1110.16,624.03 1109.72,623.58 1109.27,623.15 C1109.23,623.12 1109.2,623.09 1109.17,623.06 C1108.78,622.7 1108.38,622.37 1107.96,622.04 C1107.84,621.95 1107.72,621.86 1107.6,621.77 C1106.33,620.84 1104.96,620.1 1103.52,619.58 C1103.13,619.44 1102.74,619.31 1102.34,619.21 C1101.09,618.87 1099.79,618.68 1098.45,618.68 C1098.45,618.68 761.86,618.68 761.86,618.68 C760.92,618.68 760,618.77 759.11,618.94 C757.91,619.16 756.75,619.54 755.65,620.04 C755.37,620.17 755.1,620.3 754.83,620.44 C752.94,621.43 751.22,622.82 749.72,624.51 C749.51,624.75 749.3,625 749.1,625.25 C746.14,628.95 744.22,633.94 743.9,639.5 C743.64,638.2 743.5,636.87 743.5,635.5 C743.5,635.5 743.5,630.02 743.5,630.02 C743.5,618.83 752.57,609.76 763.76,609.76 C763.76,609.76 1096.24,609.76 1096.24,609.76 C1107.43,609.76 1116.5,618.83 1116.5,630.02 C1116.5,630.02 1116.5,635.5 1116.5,635.5 C1116.5,636.38 1116.42,637.24 1116.31,638.08 C1115.97,634.97 1115.13,632.06 1113.88,629.49z "
            />
          </g>
        </g>
        <g id="_R_G_L_1_G_N_13_T_0">
          <g id="_R_G_L_1_G" transform=" translate(238.257, 279.67) translate(-249.103, -141.848)">
            <path
              id="_R_G_L_1_G_D_0_P_0"
              fill="#ffffff"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M420.59 0.25 C420.59,0.25 77.61,0.25 77.61,0.25 C34.75,0.25 0.25,34.76 0.25,77.61 C0.25,77.61 0.25,206.08 0.25,206.08 C0.25,248.94 34.75,283.45 77.61,283.45 C77.61,283.45 420.59,283.45 420.59,283.45 C463.45,283.45 497.96,248.94 497.96,206.08 C497.96,206.08 497.96,77.61 497.96,77.61 C497.96,34.76 463.45,0.25 420.59,0.25z  M441.81 144.8 C441.81,149.08 440.86,153.08 439.21,156.48 C438.99,156.92 438.76,157.35 438.52,157.77 C438.19,158.36 437.84,158.92 437.47,159.46 C437.17,159.89 436.87,160.32 436.54,160.72 C436.34,160.98 436.13,161.22 435.92,161.46 C435.49,161.94 435.05,162.4 434.6,162.82 C434.57,162.85 434.53,162.88 434.5,162.91 C434.11,163.27 433.71,163.61 433.29,163.93 C433.17,164.02 433.05,164.11 432.93,164.2 C431.66,165.13 430.29,165.87 428.85,166.39 C428.46,166.53 428.07,166.66 427.67,166.77 C426.42,167.11 425.12,167.29 423.78,167.29 C423.78,167.29 87.19,167.29 87.19,167.29 C86.25,167.29 85.33,167.21 84.44,167.04 C83.24,166.81 82.08,166.44 80.98,165.93 C80.7,165.81 80.43,165.67 80.16,165.53 C78.27,164.54 76.55,163.16 75.05,161.46 C74.84,161.22 74.63,160.98 74.43,160.72 C71.17,156.66 69.16,151.03 69.16,144.8 C69.16,141.18 69.84,137.77 71.05,134.75 C71.4,133.87 71.79,133.02 72.23,132.21 C72.39,131.91 72.56,131.61 72.73,131.33 C73.25,130.46 73.82,129.65 74.43,128.88 C74.73,128.51 75.05,128.15 75.37,127.8 C75.59,127.56 75.81,127.33 76.04,127.1 C76.28,126.87 76.52,126.65 76.76,126.43 C77.11,126.13 77.46,125.83 77.83,125.56 C78.07,125.37 78.33,125.19 78.58,125.02 C79.09,124.67 79.62,124.36 80.16,124.07 C80.43,123.93 80.7,123.8 80.98,123.67 C82.08,123.17 83.24,122.8 84.44,122.57 C85.33,122.4 86.25,122.31 87.19,122.31 C87.19,122.31 423.78,122.31 423.78,122.31 C429.4,122.31 434.4,125.48 437.7,130.48 C437.89,130.75 438.07,131.04 438.24,131.33 C438.58,131.9 438.91,132.5 439.21,133.12 C439.36,133.43 439.5,133.74 439.64,134.06 C441.03,137.25 441.81,140.91 441.81,144.8z "
            />
            <path
              id="_R_G_L_1_G_D_1_P_0"
              fill="#ffffff"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M439.21 156.48 C438.99,156.92 438.76,157.35 438.52,157.77 C438.19,158.36 437.84,158.92 437.47,159.46 C437.17,159.89 436.87,160.32 436.54,160.72 C436.34,160.97 436.13,161.22 435.92,161.46 C435.49,161.94 435.05,162.4 434.6,162.82 C434.56,162.85 434.53,162.88 434.5,162.91 C434.11,163.27 433.71,163.61 433.29,163.93 C433.17,164.02 433.05,164.11 432.93,164.2 C431.66,165.13 430.29,165.87 428.85,166.39 C428.46,166.53 428.07,166.66 427.67,166.77 C426.42,167.11 425.12,167.29 423.78,167.29 C423.78,167.29 87.19,167.29 87.19,167.29 C86.25,167.29 85.33,167.21 84.44,167.04 C83.24,166.81 82.08,166.44 80.98,165.93 C80.7,165.81 80.43,165.67 80.16,165.53 C78.27,164.54 76.55,163.16 75.05,161.46 C74.84,161.22 74.63,160.97 74.43,160.72 C71.47,157.02 69.55,152.03 69.23,146.48 C68.97,147.77 68.83,149.11 68.83,150.48 C68.83,150.48 68.83,155.96 68.83,155.96 C68.83,167.15 77.9,176.22 89.09,176.22 C89.09,176.22 421.57,176.22 421.57,176.22 C432.76,176.22 441.83,167.15 441.83,155.96 C441.83,155.96 441.83,150.48 441.83,150.48 C441.83,149.6 441.75,148.74 441.64,147.89 C441.3,151 440.46,153.91 439.21,156.48z "
            />
            <path
              id="_R_G_L_1_G_D_2_P_0"
              fill="#ffffff"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M420.59 276.45 C420.59,276.45 77.61,276.45 77.61,276.45 C34.75,276.45 0.25,241.94 0.25,199.08 C0.25,199.08 0.25,206.08 0.25,206.08 C0.25,248.94 34.75,283.45 77.61,283.45 C77.61,283.45 420.59,283.45 420.59,283.45 C463.45,283.45 497.95,248.94 497.95,206.08 C497.95,206.08 497.95,199.08 497.95,199.08 C497.95,241.94 463.45,276.45 420.59,276.45z "
            />
          </g>
        </g>
        <g id="_R_G_L_0_G_N_13_T_0">
          <g id="_R_G_L_0_G" opacity="0.33" transform=" translate(238.257, 279.67) translate(-249.103, -141.848)">
            <path
              id="_R_G_L_0_G_D_0_P_0"
              className="fill-primary"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M420.59 0.25 C420.59,0.25 77.61,0.25 77.61,0.25 C34.75,0.25 0.25,34.76 0.25,77.61 C0.25,77.61 0.25,206.08 0.25,206.08 C0.25,248.94 34.75,283.45 77.61,283.45 C77.61,283.45 420.59,283.45 420.59,283.45 C463.45,283.45 497.96,248.94 497.96,206.08 C497.96,206.08 497.96,77.61 497.96,77.61 C497.96,34.76 463.45,0.25 420.59,0.25z  M441.81 144.8 C441.81,149.08 440.86,153.08 439.21,156.48 C438.99,156.92 438.76,157.35 438.52,157.77 C438.19,158.36 437.84,158.92 437.47,159.46 C437.17,159.89 436.87,160.32 436.54,160.72 C436.34,160.98 436.13,161.22 435.92,161.46 C435.49,161.94 435.05,162.4 434.6,162.82 C434.57,162.85 434.53,162.88 434.5,162.91 C434.11,163.27 433.71,163.61 433.29,163.93 C433.17,164.02 433.05,164.11 432.93,164.2 C431.66,165.13 430.29,165.87 428.85,166.39 C428.46,166.53 428.07,166.66 427.67,166.77 C426.42,167.11 425.12,167.29 423.78,167.29 C423.78,167.29 87.19,167.29 87.19,167.29 C86.25,167.29 85.33,167.21 84.44,167.04 C83.24,166.81 82.08,166.44 80.98,165.93 C80.7,165.81 80.43,165.67 80.16,165.53 C78.27,164.54 76.55,163.16 75.05,161.46 C74.84,161.22 74.63,160.98 74.43,160.72 C71.17,156.66 69.16,151.03 69.16,144.8 C69.16,141.18 69.84,137.77 71.05,134.75 C71.4,133.87 71.79,133.02 72.23,132.21 C72.39,131.91 72.56,131.61 72.73,131.33 C73.25,130.46 73.82,129.65 74.43,128.88 C74.73,128.51 75.05,128.15 75.37,127.8 C75.59,127.56 75.81,127.33 76.04,127.1 C76.28,126.87 76.52,126.65 76.76,126.43 C77.11,126.13 77.46,125.83 77.83,125.56 C78.07,125.37 78.33,125.19 78.58,125.02 C79.09,124.67 79.62,124.36 80.16,124.07 C80.43,123.93 80.7,123.8 80.98,123.67 C82.08,123.17 83.24,122.8 84.44,122.57 C85.33,122.4 86.25,122.31 87.19,122.31 C87.19,122.31 423.78,122.31 423.78,122.31 C429.4,122.31 434.4,125.48 437.7,130.48 C437.89,130.75 438.07,131.04 438.24,131.33 C438.58,131.9 438.91,132.5 439.21,133.12 C439.36,133.43 439.5,133.74 439.64,134.06 C441.03,137.25 441.81,140.91 441.81,144.8z "
            />
            <path
              id="_R_G_L_0_G_D_1_P_0"
              className="fill-primary"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M439.21 156.48 C438.99,156.92 438.76,157.35 438.52,157.77 C438.19,158.36 437.84,158.92 437.47,159.46 C437.17,159.89 436.87,160.32 436.54,160.72 C436.34,160.97 436.13,161.22 435.92,161.46 C435.49,161.94 435.05,162.4 434.6,162.82 C434.56,162.85 434.53,162.88 434.5,162.91 C434.11,163.27 433.71,163.61 433.29,163.93 C433.17,164.02 433.05,164.11 432.93,164.2 C431.66,165.13 430.29,165.87 428.85,166.39 C428.46,166.53 428.07,166.66 427.67,166.77 C426.42,167.11 425.12,167.29 423.78,167.29 C423.78,167.29 87.19,167.29 87.19,167.29 C86.25,167.29 85.33,167.21 84.44,167.04 C83.24,166.81 82.08,166.44 80.98,165.93 C80.7,165.81 80.43,165.67 80.16,165.53 C78.27,164.54 76.55,163.16 75.05,161.46 C74.84,161.22 74.63,160.97 74.43,160.72 C71.47,157.02 69.55,152.03 69.23,146.48 C68.97,147.77 68.83,149.11 68.83,150.48 C68.83,150.48 68.83,155.96 68.83,155.96 C68.83,167.15 77.9,176.22 89.09,176.22 C89.09,176.22 421.57,176.22 421.57,176.22 C432.76,176.22 441.83,167.15 441.83,155.96 C441.83,155.96 441.83,150.48 441.83,150.48 C441.83,149.6 441.75,148.74 441.64,147.89 C441.3,151 440.46,153.91 439.21,156.48z "
            />
            <path
              id="_R_G_L_0_G_D_2_P_0"
              className="fill-primary"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M420.59 276.45 C420.59,276.45 77.61,276.45 77.61,276.45 C34.75,276.45 0.25,241.94 0.25,199.08 C0.25,199.08 0.25,206.08 0.25,206.08 C0.25,248.94 34.75,283.45 77.61,283.45 C77.61,283.45 420.59,283.45 420.59,283.45 C463.45,283.45 497.95,248.94 497.95,206.08 C497.95,206.08 497.95,199.08 497.95,199.08 C497.95,241.94 463.45,276.45 420.59,276.45z "
            />
          </g>
        </g>
      </g>
      <g id="time_group" />
    </svg>
  )
}
